// extracted by mini-css-extract-plugin
export default {"formTextarea":"kdki19R_tglF0pFlFQwy","fadeIn":"jUgCc2bE3T0sgwuH5CxN"};